import type * as Actions from './actions';
import { ActionTypes } from './actionTypes';

import type {
  MaintenanceOption,
  PastMaintenance,
  RegisterPastMaintenance,
  ReminderPrefill,
} from '@cobliteam/api-lib';

export const loadMaintenanceItemOptionsRequest =
  (): Actions.LoadMaintenanceItemOptionsRequest => ({
    type: ActionTypes.LOAD_MAINTENANCE_ITEM_OPTIONS_REQUEST,
  });

export const loadMaintenanceItemOptionsSucceeded = (
  items: MaintenanceOption[]
): Actions.LoadMaintenanceItemOptionsSucceeded => ({
  type: ActionTypes.LOAD_MAINTENANCE_ITEM_OPTIONS_SUCCEEDED,
  payload: items,
});

export const loadMaintenanceItemOptionsFailed =
  (): Actions.LoadMaintenanceItemOptionsFailed => ({
    type: ActionTypes.LOAD_MAINTENANCE_ITEM_OPTIONS_FAILED,
  });

export const maskMaintenanceAsDoneRequest = (
  prefill: ReminderPrefill
): Actions.MaskMaintenanceAsDoneRequest => ({
  type: ActionTypes.MARK_MAINTENANCE_AS_DONE_REQUEST,
  payload: prefill,
});

export const editMaintenanceRequest = (
  maintenance: PastMaintenance
): Actions.EditMaintenanceRequest => ({
  type: ActionTypes.EDIT_MAINTENANCE_REQUEST,
  payload: maintenance,
});

export const registerMaintenanceRequest =
  (): Actions.RegisterMaintenanceRequest => ({
    type: ActionTypes.REGISTER_MAINTENANCE_REQUEST,
  });

export const deleteMaintenanceRequest = (
  maintenance: PastMaintenance
): Actions.DeleteMaintenanceRequest => ({
  type: ActionTypes.DELETE_MAINTENANCE_REQUEST,
  payload: maintenance,
});

export const saveMaintenanceMarkedAsDoneRequest = (
  maintenance: RegisterPastMaintenance
): Actions.SaveMaintenanceMarkedAsDoneRequest => ({
  type: ActionTypes.SAVE_MAINTENANCE_MARKED_AS_DONE_REQUEST,
  payload: maintenance,
});

export const saveMaintenanceRegistryRequest = (
  maintenance: RegisterPastMaintenance
): Actions.SaveMaintenanceRegistryRequest => ({
  type: ActionTypes.SAVE_MAINTENANCE_REGISTRY_REQUEST,
  payload: maintenance,
});
